import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import AnalyticsService from "../../Services/AnalyticsService";
import { format, isToday } from "date-fns";

const PictureInPicture = ({ mediaUrl, redirectionUrl, id }) => {
  const [visible, setVisible] = useState(false);
  let navigate = useNavigate();

  useEffect(() => {
    const storePipPlayerData = JSON.parse(
      localStorage.getItem("pipPlayerData") || "{}"
    );

    const {
      closedCount = 0,
      lastClosedDate = "",
      contentId = "",
    } = storePipPlayerData;

    const wasClosedToday = lastClosedDate && isToday(new Date(lastClosedDate));

    // reset the closedCount if new content is loaded
    if (contentId !== id) {
      localStorage.setItem(
        "pipPlayerData",
        JSON.stringify({
          closedCount: 0,
          lastClosedDate: "",
          contentId: id,
        })
      );
      setVisible(true);
    } else if (closedCount < 3 && !wasClosedToday) {
      setVisible(true);
    }
  }, [id]);

  const handleClose = (event) => {
    AnalyticsService.pushEvent("Button Clicked", {
      type: "Close Picture-In-Picture Player",
      mediaUrl: mediaUrl,
      redirectionUrl: redirectionUrl,
    });
    event.stopPropagation();
    setVisible(false);

    const today = new Date();
    const formattedDateToday = format(today, "yyyy-MM-dd");

    const storePipPlayerData = JSON.parse(
      localStorage.getItem("pipPlayerData") || "{}"
    );
    let closedCount = storePipPlayerData.closedCount || 0;
    closedCount += 1;

    localStorage.setItem(
      "pipPlayerData",
      JSON.stringify({
        closedCount,
        lastClosedDate: formattedDateToday,
        contentId: id,
      })
    );
  };

  const handleRedirect = () => {
    AnalyticsService.pushEvent("Button Clicked", {
      type: "Picture-In-Picture Player",
      mediaUrl: mediaUrl,
      redirectionUrl: redirectionUrl,
    });
    navigate(redirectionUrl);
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      onClick={handleRedirect}
      sx={{
        position: "fixed",
        bottom: 75,
        left: 16,
        height: "24vh",
        width: "16vh",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        backgroundColor: "#fff",
        zIndex: 1000,
        borderRadius: "16px",
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          top: 5,
          right: 5,
          backgroundColor: "rgba(255,255,255,0.8)",
          zIndex: 10,
          padding: "4px",
        }}
        onClick={handleClose}
      >
        <CloseIcon sx={{ fontSize: "18px" }} />
      </IconButton>

      <Box
        component="img"
        src={mediaUrl}
        alt=""
        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </Box>
  );
};

export default PictureInPicture;
